export default "__VITE_ASSET__BiBfknGH__"